<script setup>
import MarketingListComponent from "@/Components/Marketing/MarketingListComponent.vue";
import {Permissions} from "@/Utils/Permissions";
</script>

<template>
  <v-container fluid style="min-height: 100vh;">
    <v-row v-if="Permissions.checkPermissions(['marketing.get-rules'])">
      <v-col cols="12">
        <MarketingListComponent/>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>

</style>